// import React from 'react';
// import * as AiIcons from 'react-icons/ai';
// import * as BsIcons from 'react-icons/bs';
// import * as BiIcons from 'react-icons/bi';
// import * as CiIcons from 'react-icons/ci';
// import * as CgIcons from 'react-icons/cg';
// import * as DiIcons from 'react-icons/di';
// import * as FiIcons from 'react-icons/fi';
// import * as FcIcons from 'react-icons/fc';
// import * as FaIcons from 'react-icons/fa';
// import * as Fa6Icons from 'react-icons/fa6';
// import * as GiIcons from 'react-icons/gi';
// import * as GoIcons from 'react-icons/go';
// import * as GrIcons from 'react-icons/gr';
// import * as HiIcons from 'react-icons/hi';
// import * as Hi2Icons from 'react-icons/hi2';
// import * as ImIcons from 'react-icons/im';
// import * as LiaIcons from 'react-icons/lia';
// import * as IoIcons from 'react-icons/io';
// import * as Io5Icons from 'react-icons/io5';
// import * as LuIcons from 'react-icons/lu';
// import * as MdIcons from 'react-icons/md';
// import * as PiIcons from 'react-icons/pi';
// import * as RxIcons from 'react-icons/rx';
// import * as RiIcons from 'react-icons/ri';
// import * as SiIcons from 'react-icons/si';
// import * as SlIcons from 'react-icons/sl';
// import * as TbIcons from 'react-icons/tb';
// import * as TfiIcons from 'react-icons/tfi';
// import * as TiIcons from 'react-icons/ti';
// import * as VscIcons from 'react-icons/vsc';
// import * as WiIcons from 'react-icons/wi';

// const allIcons = {
//   ...AiIcons,
//   ...BsIcons,
//   ...BiIcons,
//   ...CiIcons,
//   ...CgIcons,
//   ...DiIcons,
//   ...FiIcons,
//   ...FcIcons,
//   ...FaIcons,
//   ...Fa6Icons,
//   ...GiIcons,
//   ...GoIcons,
//   ...GrIcons,
//   ...HiIcons,
//   ...Hi2Icons,
//   ...ImIcons,
//   ...LiaIcons,
//   ...IoIcons,
//   ...Io5Icons,
//   ...LuIcons,
//   ...MdIcons,
//   ...PiIcons,
//   ...RxIcons,
//   ...RiIcons,
//   ...SiIcons,
//   ...SlIcons,
//   ...TbIcons,
//   ...TfiIcons,
//   ...TiIcons,
//   ...VscIcons,
//   ...WiIcons,
// };

// const DynamicIcon = ({ icon, size = 24 }) => {
//   if (!icon) {
//     console.warn('No icon provided to DynamicIcon component');
//     return null;
//   }

//   try {
//     // Extract icon name from the JSX string (e.g., "<GrInspect />" -> "GrInspect")
//     const iconName = icon.replace(/[</>]/g, '').trim();
    
//     // Get the icon component from our collection
//     const IconComponent = allIcons[iconName];

//     if (!IconComponent) {
//       console.warn(`Icon "${iconName}" not found`);
//       return <RiIcons.RiComputerFill />;
//     }

//     return <IconComponent size={size} />;
//   } catch (error) {
//     console.error('Error rendering icon:', error);
//     return null;
//   }
// };

// export default DynamicIcon;
import React from 'react';
import * as LucideIcons from 'lucide-react';

const DynamicIcon = ({ name, size = 24, color, className }) => {
  if (!name) {
    console.warn('No icon name provided to DynamicIcon component');
    return null;
  }

  try {
    // Clean the icon name whether it's in JSX format or plain text
    let cleanIconName = name;
    
    // If it's in JSX format (e.g., <Computer />)
    if (name.startsWith('<') && name.endsWith('>')) {
      cleanIconName = name.replace(/[<>/]/g, '').trim();
    }
    // If it's just the name (e.g., Computer)
    else {
      cleanIconName = name.trim();
    }

    // Get the icon component from Lucide icons
    const IconComponent = LucideIcons[cleanIconName];

    if (!IconComponent) {
      console.warn(`Icon "${cleanIconName}" not found in Lucide icons`);
      return <LucideIcons.Computer size={size} color={color} className={className} />;
    }

    return <IconComponent size={size} color={color} className={className} />;
  } catch (error) {
    console.error('Error rendering Lucide icon:', error);
    return <LucideIcons.AlertCircle color="red" size={size} className={className} />;
  }
};

export default DynamicIcon;